import { Attachment } from '../@types'

export const canQuitEditor = ({
  isTouched: _isTouched,
  attachments,
  initialAttachments,
}: {
  isTouched: boolean
  attachments: Attachment[]
  initialAttachments: Attachment[]
}) => {
  const initialAttachmentsId = initialAttachments.reduce(
    (acc, { id }) => acc + id,
    '',
  )
  const attachmentsId = attachments.reduce((acc, { id }) => acc + id, '')

  // Check if any attachments were added, removed or replaced with others
  const anyChangeInAttachments = initialAttachmentsId !== attachmentsId

  const isTouched = _isTouched || anyChangeInAttachments

  return (
    !isTouched ||
    // eslint-disable-next-line no-alert
    window.confirm(
      'You have unsaved changes. Are you sure you want to discard them?',
    )
  )
}
